<template>
    <div class="feedback-container">

        <transition name="fade"> <p class="text-success" v-if="hasSuccess"> {{ successFeedback }} </p> </transition>

        <transition name="fade"> <p class="text-danger" v-if="hasFail"> {{ failFeedback }} </p> </transition>

        <transition name="fade">
            <section class="alert alert-danger my-4" v-show="(Object.keys(errors).length > 0)">
                <div v-for="errorProp in errors">
                    <span v-for="message in errorProp"> {{ message }} </span>
                </div>
            </section>
        </transition>

    </div>

</template>

<script>

export default {

    props: {

        successFeedback: {
            type : String,
            default : ""
        },

        failFeedback: {
            type : String,
            default : ""
        },

        errors: {
            type : Object | Array,
            default : () => {return {};}
        },

        fadeTimeout: {
            type: Number,
            default: 3000,
        },
    },

    data() {
        return {
            hasSuccess: false,
            hasFail: false,
        };
    },

    watch: {

        successFeedback() {
            this.hasSuccess = true;

            setTimeout(() => {
                this.hasSuccess = false;
            }, this.fadeTimeout);
        },

        failFeedback() {
            this.hasFail = true;

            setTimeout(() => {
                this.hasFail = false;
            }, this.fadeTimeout);
        }

    }

};

</script>



// WEBPACK FOOTER //
// resources/assets/js/components/feedback/StatusFeedbackComponent.vue